import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators, compose} from "redux";
import styled from "styled-components";
import {IntlProvider, addLocaleData} from "react-intl";
import en from "react-intl/locale-data/en";
import fr from "react-intl/locale-data/fr";
import {CSSTransition} from "react-transition-group";
import {
    getIsCartInitialised,
    getIsAppInitialised,
    getIsAppExpanded,
    getLocale,
    getIsMobile,
} from "rootReducer";
import {Cart} from "containers/Cart";
import {isEmpty} from "../../utils";
import localeData_en from "../../locale/en.json"; // eslint-disable-line camelcase
import localeData_fr from "../../locale/fr.json"; // eslint-disable-line camelcase

import {
    initialiseApp,
    warnCloseAppWindow,
    toggleAppVisibility,
    closeApp,
    setAppLocale,
    updateRoute,
    setIsMobile,
    fetchWebSocketId,
} from "../actionCreators";

addLocaleData([...en, ...fr]);

const messages = {
    fr: {...localeData_fr}, // eslint-disable-line camelcase
    en: {...localeData_en}, // eslint-disable-line camelcase
};

if (isEmpty(window.ChatApp)) window.ChatApp = {};

const AppWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    height: 100%;
    width: 100%;
    ${(props) =>
        props.showCollapsedState
            ? `
    transform: translateY(100%) translateY(-45px);
    transition: all 1s ease-out; `
            : `
    transform: translateY(0));
    transition: all 1s ease-out;
  `}
`;

class App extends Component {
    static propTypes = {
        isAppInitialised: PropTypes.bool.isRequired,
        isAppExpanded: PropTypes.bool.isRequired,
        locale: PropTypes.string.isRequired,
        appActions: PropTypes.object.isRequired,
        isCartInitialised: PropTypes.bool.isRequired,
        isMobile: PropTypes.bool,
    };

    componentDidMount() {
        this.props.appActions.initialiseApp();
        this.bindChatButtonEntries();
        this.props.appActions.fetchWebSocketId();
        window.addEventListener("message", this.onMessageReceivedListener);
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.onMessageReceivedListener);
    }

    onMessageReceivedListener = (e) => {
        this.onMessageReceived(e);
    }

    onMessageReceived = (msg) => {
        if (msg.data.screen === "mobile") {
            this.props.appActions.setIsMobile(true);
        } else if (msg.data.screen === "desktop") {
            this.props.appActions.setIsMobile(false);
        }
    };
    /* This allows for the re-mounting of the app. */
    bindChatButtonEntries = () => {
        /* Bind action to DOM buttons outside of React. */
        if (!isEmpty(window.ChatApp) && window.ChatApp.state !== undefined) {
            let i = 0;
            for (i = 0; i < window.ChatApp.state.nodeList.length; i += 1) {
                window.ChatApp.state.nodeList[i].addEventListener("click", () => {
                    if (!this.props.isAppInitialised) {
                        this.props.appActions.initialiseApp();
                    }
                });
            }
        }
    };

    showCollapsedState = () => {
        const {isAppInitialised, isAppExpanded} = this.props;
        return isAppInitialised && !isAppExpanded;
    };

    render() {
        const {
            showCollapsedState,
            props: {locale, appActions, isAppExpanded, isAppInitialised, isCartInitialised, isMobile},
        } = this;
        return (
            <CSSTransition
                in={isAppInitialised}
                classNames={isMobile ? "" : "SlideIn"}
                transitionAppear
                timeout={1000}
                unmountOnExit
            >
                <IntlProvider locale={locale} messages={messages[locale]}>
                    <AppWrapper showCollapsedState={showCollapsedState()}>
                        {isCartInitialised && <Cart />}
                    </AppWrapper>
                </IntlProvider>
            </CSSTransition>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    appActions: bindActionCreators(
        {
            warnCloseAppWindow,
            closeApp,
            setIsMobile,
            toggleAppVisibility,
            initialiseApp,
            setAppLocale,
            updateRoute,
            fetchWebSocketId,
        },
        dispatch,
    ),
});

const mapStateToProps = (state) => ({
    isAppExpanded: getIsAppExpanded(state),
    isAppInitialised: getIsAppInitialised(state),
    locale: getLocale(state),
    isCartInitialised: getIsCartInitialised(state),
    messages: state.app.messages,
    isMobile: getIsMobile(state),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.js